var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',{staticClass:"shop-breadcrumb",attrs:{"separator":_vm.separator}},_vm._l((_vm.breadcrumbList),function(item,index){return _c('BreadcrumbItem',{key:index,attrs:{"to":_vm.skip ? {path: item.path,
                  query: {
                    ymsProductCategoryId:item.ymsProductCategoryId,
                    productCategoryCode: item.productCategoryCode
                  }
                  } : ''}},[_vm._v(_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }